module.exports = __webpack_public_path__ + "img/19.c45dea4e.png";